export const RESET_COURIER_STATE = "RESET_COURIER_STATE";

// Zones
export const GET_COURIER_ZONES_REQUEST = "GET_COURIER_ZONES_REQUEST";
export const GET_COURIER_ZONES_SUCCESS = "GET_COURIER_ZONES_SUCCESS";
export const GET_COURIER_ZONES_FAILURE = "GET_COURIER_ZONES_FAILURE";

export const CREATE_COURIER_ZONE_REQUEST = "CREATE_COURIER_ZONE_REQUEST";
export const CREATE_COURIER_ZONE_SUCCESS = "CREATE_COURIER_ZONE_SUCCESS";
export const CREATE_COURIER_ZONE_FAILURE = "CREATE_COURIER_ZONE_FAILURE";

export const UPDATE_COURIER_ZONE_REQUEST = "UPDATE_COURIER_ZONE_REQUEST";
export const UPDATE_COURIER_ZONE_SUCCESS = "UPDATE_COURIER_ZONE_SUCCESS";
export const UPDATE_COURIER_ZONE_FAILURE = "UPDATE_COURIER_ZONE_FAILURE";

export const DELETE_COURIER_ZONE_REQUEST = "DELETE_COURIER_ZONE_REQUEST";
export const DELETE_COURIER_ZONE_SUCCESS = "DELETE_COURIER_ZONE_SUCCESS";
export const DELETE_COURIER_ZONE_FAILURE = "DELETE_COURIER_ZONE_FAILURE";

export const REORDER_COURIER_ZONES_REQUEST = "REORDER_COURIER_ZONES_REQUEST";
export const REORDER_COURIER_ZONES_SUCCESS = "REORDER_COURIER_ZONES_SUCCESS";
export const REORDER_COURIER_ZONES_FAILURE = "REORDER_COURIER_ZONES_FAILURE";

// Centers
export const GET_COURIER_CENTERS_REQUEST = "GET_COURIER_CENTERS_REQUEST";
export const GET_COURIER_CENTERS_SUCCESS = "GET_COURIER_CENTERS_SUCCESS";
export const GET_COURIER_CENTERS_FAILURE = "GET_COURIER_CENTERS_FAILURE";

export const CREATE_COURIER_CENTER_REQUEST = "CREATE_COURIER_CENTER_REQUEST";
export const CREATE_COURIER_CENTER_SUCCESS = "CREATE_COURIER_CENTER_SUCCESS";
export const CREATE_COURIER_CENTER_FAILURE = "CREATE_COURIER_CENTER_FAILURE";

export const UPDATE_COURIER_CENTER_REQUEST = "UPDATE_COURIER_CENTER_REQUEST";
export const UPDATE_COURIER_CENTER_SUCCESS = "UPDATE_COURIER_CENTER_SUCCESS";
export const UPDATE_COURIER_CENTER_FAILURE = "UPDATE_COURIER_CENTER_FAILURE";

export const DELETE_COURIER_CENTER_REQUEST = "DELETE_COURIER_CENTER_REQUEST";
export const DELETE_COURIER_CENTER_SUCCESS = "DELETE_COURIER_CENTER_SUCCESS";
export const DELETE_COURIER_CENTER_FAILURE = "DELETE_COURIER_CENTER_FAILURE";

export const REORDER_COURIER_ZONE_CENTERS_REQUEST =
  "REORDER_COURIER_ZONE_CENTERS_REQUEST";
export const REORDER_COURIER_ZONE_CENTERS_SUCCESS =
  "REORDER_COURIER_ZONE_CENTERS_SUCCESS";
export const REORDER_COURIER_ZONE_CENTERS_FAILURE =
  "REORDER_COURIER_ZONE_CENTERS_FAILURE";

// Couriers
export const GET_COURIERS_REQUEST = "GET_COURIERS_REQUEST";
export const GET_COURIERS_SUCCESS = "GET_COURIERS_SUCCESS";
export const GET_COURIERS_FAILURE = "GET_COURIERS_FAILURE";

export const CREATE_COURIER_REQUEST = "CREATE_COURIER_REQUEST";
export const CREATE_COURIER_SUCCESS = "CREATE_COURIER_SUCCESS";
export const CREATE_COURIER_FAILURE = "CREATE_COURIER_FAILURE";

export const UPDATE_COURIER_REQUEST = "UPDATE_COURIER_REQUEST";
export const UPDATE_COURIER_SUCCESS = "UPDATE_COURIER_SUCCESS";
export const UPDATE_COURIER_FAILURE = "UPDATE_COURIER_FAILURE";

// Rounds
export const GET_COURIER_ROUNDS_REQUEST = "GET_COURIER_ROUNDS_REQUEST";
export const GET_COURIER_ROUNDS_SUCCESS = "GET_COURIER_ROUNDS_SUCCESS";
export const GET_COURIER_ROUNDS_FAILURE = "GET_COURIER_ROUNDS_FAILURE";

export const CREATE_COURIER_ROUND_REQUEST = "CREATE_COURIER_ROUND_REQUEST";
export const CREATE_COURIER_ROUND_SUCCESS = "CREATE_COURIER_ROUND_SUCCESS";
export const CREATE_COURIER_ROUND_FAILURE = "CREATE_COURIER_ROUND_FAILURE";

export const UPDATE_COURIER_ROUND_REQUEST = "UPDATE_COURIER_ROUND_REQUEST";
export const UPDATE_COURIER_ROUND_SUCCESS = "UPDATE_COURIER_ROUND_SUCCESS";
export const UPDATE_COURIER_ROUND_FAILURE = "UPDATE_COURIER_ROUND_FAILURE";

export const DELETE_COURIER_ROUND_REQUEST = "DELETE_COURIER_ROUND_REQUEST";
export const DELETE_COURIER_ROUND_SUCCESS = "DELETE_COURIER_ROUND_SUCCESS";
export const DELETE_COURIER_ROUND_FAILURE = "DELETE_COURIER_ROUND_FAILURE";

// Round stops
export const GET_COURIER_ROUND_STOPS_REQUEST = "GET_COURIER_ROUND_STOPS_REQUEST";
export const GET_COURIER_ROUND_STOPS_SUCCESS = "GET_COURIER_ROUND_STOPS_SUCCESS";
export const GET_COURIER_ROUND_STOPS_FAILURE = "GET_COURIER_ROUND_STOPS_FAILURE";

export const CREATE_COURIER_ROUND_STOP_REQUEST =
  "CREATE_COURIER_ROUND_STOP_REQUEST";
export const CREATE_COURIER_ROUND_STOP_SUCCESS =
  "CREATE_COURIER_ROUND_STOP_SUCCESS";
export const CREATE_COURIER_ROUND_STOP_FAILURE =
  "CREATE_COURIER_ROUND_STOP_FAILURE";

export const DELETE_COURIER_ROUND_STOP_REQUEST =
  "DELETE_COURIER_ROUND_STOP_REQUEST";
export const DELETE_COURIER_ROUND_STOP_SUCCESS =
  "DELETE_COURIER_ROUND_STOP_SUCCESS";
export const DELETE_COURIER_ROUND_STOP_FAILURE =
  "DELETE_COURIER_ROUND_STOP_FAILURE";

export const REORDER_COURIER_ROUND_STOPS_REQUEST =
  "REORDER_COURIER_ROUND_STOPS_REQUEST";
export const REORDER_COURIER_ROUND_STOPS_SUCCESS =
  "REORDER_COURIER_ROUND_STOPS_SUCCESS";
export const REORDER_COURIER_ROUND_STOPS_FAILURE =
  "REORDER_COURIER_ROUND_STOPS_FAILURE";

// Round schedules
export const GET_COURIER_ROUND_SCHEDULES_REQUEST =
  "GET_COURIER_ROUND_SCHEDULES_REQUEST";
export const GET_COURIER_ROUND_SCHEDULES_SUCCESS =
  "GET_COURIER_ROUND_SCHEDULES_SUCCESS";
export const GET_COURIER_ROUND_SCHEDULES_FAILURE =
  "GET_COURIER_ROUND_SCHEDULES_FAILURE";

export const CREATE_COURIER_ROUND_SCHEDULE_REQUEST =
  "CREATE_COURIER_ROUND_SCHEDULE_REQUEST";
export const CREATE_COURIER_ROUND_SCHEDULE_SUCCESS =
  "CREATE_COURIER_ROUND_SCHEDULE_SUCCESS";
export const CREATE_COURIER_ROUND_SCHEDULE_FAILURE =
  "CREATE_COURIER_ROUND_SCHEDULE_FAILURE";

export const DELETE_COURIER_ROUND_SCHEDULE_REQUEST =
  "DELETE_COURIER_ROUND_SCHEDULE_REQUEST";
export const DELETE_COURIER_ROUND_SCHEDULE_SUCCESS =
  "DELETE_COURIER_ROUND_SCHEDULE_SUCCESS";
export const DELETE_COURIER_ROUND_SCHEDULE_FAILURE =
  "DELETE_COURIER_ROUND_SCHEDULE_FAILURE";

// Shifts
export const GET_COURIER_SHIFTS_REQUEST = "GET_COURIER_SHIFTS_REQUEST";
export const GET_COURIER_SHIFTS_SUCCESS = "GET_COURIER_SHIFTS_SUCCESS";
export const GET_COURIER_SHIFTS_FAILURE = "GET_COURIER_SHIFTS_FAILURE";

export const CREATE_COURIER_SHIFT_REQUEST = "CREATE_COURIER_SHIFT_REQUEST";
export const CREATE_COURIER_SHIFT_SUCCESS = "CREATE_COURIER_SHIFT_SUCCESS";
export const CREATE_COURIER_SHIFT_FAILURE = "CREATE_COURIER_SHIFT_FAILURE";

export const DELETE_COURIER_SHIFT_REQUEST = "DELETE_COURIER_SHIFT_REQUEST";
export const DELETE_COURIER_SHIFT_SUCCESS = "DELETE_COURIER_SHIFT_SUCCESS";
export const DELETE_COURIER_SHIFT_FAILURE = "DELETE_COURIER_SHIFT_FAILURE";

// Trips
export const GET_COURIER_TRIPS_REQUEST = "GET_COURIER_TRIPS_REQUEST";
export const GET_COURIER_TRIPS_SUCCESS = "GET_COURIER_TRIPS_SUCCESS";
export const GET_COURIER_TRIPS_FAILURE = "GET_COURIER_TRIPS_FAILURE";

export const GET_COURIER_TRIP_TASKS_REQUEST = "GET_COURIER_TRIP_TASKS_REQUEST";
export const GET_COURIER_TRIP_TASKS_SUCCESS = "GET_COURIER_TRIP_TASKS_SUCCESS";
export const GET_COURIER_TRIP_TASKS_FAILURE = "GET_COURIER_TRIP_TASKS_FAILURE";

export const GENERATE_COURIER_TRIPS_REQUEST = "GENERATE_COURIER_TRIPS_REQUEST";
export const GENERATE_COURIER_TRIPS_SUCCESS = "GENERATE_COURIER_TRIPS_SUCCESS";
export const GENERATE_COURIER_TRIPS_FAILURE = "GENERATE_COURIER_TRIPS_FAILURE";

export const GET_ELIGIBLE_COURIERS_REQUEST = "GET_ELIGIBLE_COURIERS_REQUEST";
export const GET_ELIGIBLE_COURIERS_SUCCESS = "GET_ELIGIBLE_COURIERS_SUCCESS";
export const GET_ELIGIBLE_COURIERS_FAILURE = "GET_ELIGIBLE_COURIERS_FAILURE";

export const ASSIGN_COURIER_TRIP_REQUEST = "ASSIGN_COURIER_TRIP_REQUEST";
export const ASSIGN_COURIER_TRIP_SUCCESS = "ASSIGN_COURIER_TRIP_SUCCESS";
export const ASSIGN_COURIER_TRIP_FAILURE = "ASSIGN_COURIER_TRIP_FAILURE";

export const CANCEL_COURIER_TRIP_REQUEST = "CANCEL_COURIER_TRIP_REQUEST";
export const CANCEL_COURIER_TRIP_SUCCESS = "CANCEL_COURIER_TRIP_SUCCESS";
export const CANCEL_COURIER_TRIP_FAILURE = "CANCEL_COURIER_TRIP_FAILURE";

// Operator workflow (Phase 4)
export const START_COURIER_TRIP_REQUEST = "START_COURIER_TRIP_REQUEST";
export const START_COURIER_TRIP_SUCCESS = "START_COURIER_TRIP_SUCCESS";
export const START_COURIER_TRIP_FAILURE = "START_COURIER_TRIP_FAILURE";

export const DELIVER_COURIER_TRIP_REQUEST = "DELIVER_COURIER_TRIP_REQUEST";
export const DELIVER_COURIER_TRIP_SUCCESS = "DELIVER_COURIER_TRIP_SUCCESS";
export const DELIVER_COURIER_TRIP_FAILURE = "DELIVER_COURIER_TRIP_FAILURE";

export const REACH_COURIER_TASK_REQUEST = "REACH_COURIER_TASK_REQUEST";
export const REACH_COURIER_TASK_SUCCESS = "REACH_COURIER_TASK_SUCCESS";
export const REACH_COURIER_TASK_FAILURE = "REACH_COURIER_TASK_FAILURE";

export const DISPATCH_COURIER_TASK_REQUEST = "DISPATCH_COURIER_TASK_REQUEST";
export const DISPATCH_COURIER_TASK_SUCCESS = "DISPATCH_COURIER_TASK_SUCCESS";
export const DISPATCH_COURIER_TASK_FAILURE = "DISPATCH_COURIER_TASK_FAILURE";

export const OUTCOME_COURIER_TASK_REQUEST = "OUTCOME_COURIER_TASK_REQUEST";
export const OUTCOME_COURIER_TASK_SUCCESS = "OUTCOME_COURIER_TASK_SUCCESS";
export const OUTCOME_COURIER_TASK_FAILURE = "OUTCOME_COURIER_TASK_FAILURE";

export const OVERRIDE_GPS_COURIER_TASK_REQUEST =
  "OVERRIDE_GPS_COURIER_TASK_REQUEST";
export const OVERRIDE_GPS_COURIER_TASK_SUCCESS =
  "OVERRIDE_GPS_COURIER_TASK_SUCCESS";
export const OVERRIDE_GPS_COURIER_TASK_FAILURE =
  "OVERRIDE_GPS_COURIER_TASK_FAILURE";

// Custody & manual jobs (Phase 5)
export const GET_COURIER_CUSTODY_ITEMS_REQUEST =
  "GET_COURIER_CUSTODY_ITEMS_REQUEST";
export const GET_COURIER_CUSTODY_ITEMS_SUCCESS =
  "GET_COURIER_CUSTODY_ITEMS_SUCCESS";
export const GET_COURIER_CUSTODY_ITEMS_FAILURE =
  "GET_COURIER_CUSTODY_ITEMS_FAILURE";

export const CREATE_COURIER_CUSTODY_ITEM_REQUEST =
  "CREATE_COURIER_CUSTODY_ITEM_REQUEST";
export const CREATE_COURIER_CUSTODY_ITEM_SUCCESS =
  "CREATE_COURIER_CUSTODY_ITEM_SUCCESS";
export const CREATE_COURIER_CUSTODY_ITEM_FAILURE =
  "CREATE_COURIER_CUSTODY_ITEM_FAILURE";

export const RECONCILE_COURIER_CUSTODY_ITEM_REQUEST =
  "RECONCILE_COURIER_CUSTODY_ITEM_REQUEST";
export const RECONCILE_COURIER_CUSTODY_ITEM_SUCCESS =
  "RECONCILE_COURIER_CUSTODY_ITEM_SUCCESS";
export const RECONCILE_COURIER_CUSTODY_ITEM_FAILURE =
  "RECONCILE_COURIER_CUSTODY_ITEM_FAILURE";

export const CREATE_COURIER_MANUAL_JOB_REQUEST =
  "CREATE_COURIER_MANUAL_JOB_REQUEST";
export const CREATE_COURIER_MANUAL_JOB_SUCCESS =
  "CREATE_COURIER_MANUAL_JOB_SUCCESS";
export const CREATE_COURIER_MANUAL_JOB_FAILURE =
  "CREATE_COURIER_MANUAL_JOB_FAILURE";

// Reports & live monitor (Phase 6)
export const GET_COURIER_REPORTS_REQUEST = "GET_COURIER_REPORTS_REQUEST";
export const GET_COURIER_REPORTS_SUCCESS = "GET_COURIER_REPORTS_SUCCESS";
export const GET_COURIER_REPORTS_FAILURE = "GET_COURIER_REPORTS_FAILURE";

export const GET_COURIER_REPORT_REQUEST = "GET_COURIER_REPORT_REQUEST";
export const GET_COURIER_REPORT_SUCCESS = "GET_COURIER_REPORT_SUCCESS";
export const GET_COURIER_REPORT_FAILURE = "GET_COURIER_REPORT_FAILURE";

export const GET_COURIER_LIVE_MONITOR_REQUEST =
  "GET_COURIER_LIVE_MONITOR_REQUEST";
export const GET_COURIER_LIVE_MONITOR_SUCCESS =
  "GET_COURIER_LIVE_MONITOR_SUCCESS";
export const GET_COURIER_LIVE_MONITOR_FAILURE =
  "GET_COURIER_LIVE_MONITOR_FAILURE";

// Optimization (Phase 7)
export const OPTIMIZE_ROUND_STOPS_REQUEST = "OPTIMIZE_ROUND_STOPS_REQUEST";
export const OPTIMIZE_ROUND_STOPS_SUCCESS = "OPTIMIZE_ROUND_STOPS_SUCCESS";
export const OPTIMIZE_ROUND_STOPS_FAILURE = "OPTIMIZE_ROUND_STOPS_FAILURE";

export const AUTO_ASSIGN_COURIER_TRIP_REQUEST =
  "AUTO_ASSIGN_COURIER_TRIP_REQUEST";
export const AUTO_ASSIGN_COURIER_TRIP_SUCCESS =
  "AUTO_ASSIGN_COURIER_TRIP_SUCCESS";
export const AUTO_ASSIGN_COURIER_TRIP_FAILURE =
  "AUTO_ASSIGN_COURIER_TRIP_FAILURE";
